// this is non-transpiled js so that it can be used in the next config
function getSentryReleaseId() {
  return `AL-WEB-${process.env.GIT_SHA || 'dev'}`;
}

module.exports = {
  getSentryReleaseId,
};
